import React, { useState } from "react";
import "./PlannerTableView.css";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import downArrowIcon from "../../assets/images/downArrowIcon.svg";
import BodySmallRegular from "../designSystem/BodySmallRegular";
import { Info } from 'lucide-react';
import { t } from "../../locales/translate";

const PlannerTableView = ({ planDates }) => {
    const [showTooltip, setShowTooltip] = useState(null);
    const HEADOFFICE = "Head Office";
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { year: "numeric", month: "short", day: "2-digit" };
        return date.toLocaleDateString("en-US", options);
    };

    const handleLeaveIconClick = (e, dateKey) => {
        e.preventDefault();
        e.stopPropagation();
        setShowTooltip(showTooltip === dateKey ? null : dateKey);
    };

    const handleLeaveIconMouseLeave = () => {
        setShowTooltip(null);
    };

    return (
        <div className="planner-table-container">
            <table className="planner-table">
                <thead>
                    <tr>
                        <th className="header-colmn">
                            <div className="colmn-container">
                                <BodySmallMedium text={t("date")} color="#1E293B" />
                                <img src={downArrowIcon} />
                            </div>
                        </th>
                        <th className="header-colmn">
                            <div className="colmn-container">
                                <BodySmallMedium text={t("city")} color="#1E293B" />
                                <img src={downArrowIcon} />
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {planDates && planDates.length > 0 ? (
                        planDates
                            .sort((a, b) => new Date(a.planDate) - new Date(b.planDate))
                            .map((plan, index) => {
                                const dateKey = `${plan.planDate}-${index}`;
                                return (
                                    <tr key={plan.id || index}>
                                        <td>
                                            <div className="date-cell-container">
                                                <BodySmallRegular text={formatDate(plan?.planDate)} color="#1E293B" />
                                                {plan.onLeave && (
                                                    <div className="leave-info-container">
                                                        <BodySmallRegular text='On Leave' color='#F23030'/>
                                                        <Info 
                                                            size={16} 
                                                            className="leave-info-icon"
                                                            onClick={(e) => handleLeaveIconClick(e, dateKey)}
                                                            onMouseLeave={handleLeaveIconMouseLeave}
                                                        />
                                                        {showTooltip === dateKey && (
                                                            <div className="leave-tooltip">
                                                                {plan.leaveMessage}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <BodySmallRegular
                                                text={
                                                    plan.planDetails[0]?.cityName ? (
                                                        plan.planDetails[0].cityName
                                                    ) : plan.planDetails[0]?.headOffice ? (
                                                        HEADOFFICE
                                                    ) : (
                                                        <span className="not-available-text">Not available</span>
                                                    )
                                                }
                                                color="#1E293B"
                                            />
                                        </td>
                                    </tr>
                                );
                            })
                    ) : (
                        <tr>
                            <td colSpan="2" style={{ textAlign: "center", padding: "20px",  display: document.body.dir === "rtl" ? "inline" : "" }}>
                                <BodySmallRegular textAlign="center" text={t("noDataFound")} color="#1E293B" />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default PlannerTableView;